import { Injectable, inject } from '@angular/core';
import { UserService } from './user.service';
import { Observable, map, of, shareReplay } from 'rxjs';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private userService = inject(UserService);
  private currentUser: User | null = null;
  private userRoles: string[] = [];

  /**
   * Get the current user with roles
   */
  getCurrentUser(): Observable<User | null> {
    if (this.currentUser) {
      return of(this.currentUser);
    }

    return this.userService.getCurrentUser().pipe(
      map(user => {
        this.currentUser = user;
        this.userRoles = user?.roles || [];
        return user;
      }),
      shareReplay(1)
    );
  }

  /**
   * Check if the current user has a specific role
   */
  hasRole(role: string): Observable<boolean> {
    if (this.currentUser) {
      return of(this.userRoles.includes(role));
    }

    return this.getCurrentUser().pipe(
      map(user => {
        return user?.roles?.includes(role) || false;
      })
    );
  }

  /**
   * Clear the cached user data
   */
  clearCache(): void {
    this.currentUser = null;
    this.userRoles = [];
  }
}
